import { render, staticRenderFns } from "./CourseRegistration.vue?vue&type=template&id=264bb82e"
import script from "./CourseRegistration.vue?vue&type=script&lang=js"
export * from "./CourseRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports